import { Person, Search, Settings } from '@tunasong/icons'
import { Add, Favorite, Home, Tool } from '@tunasong/icons'
import { usePlugins } from '@tunasong/plugin-lib'
import type { Entity, EntityType, Persisted } from '@tunasong/schemas'
import { useSearchDialog } from '@tunasong/search'
import { useLocation, useNavigate } from '@tunasong/ui-lib'
import { useCallback, useState } from 'react'
import CreateEntityDialog from '../entity/create-entity-dialog.js'
import ToolsDialog from './tools-dialog.js'
import styles from './mobile-navigation.module.css'

interface MobileNavigationProps {
  /** Name, icon of the views */
  entity?: Persisted<Entity>
  createNew?: EntityType[] | boolean
}
export function MobileNavigation(props: MobileNavigationProps) {
  const { entity, createNew = false } = props

  const location = useLocation()
  const isHome = location.pathname === '/app'
  const isProfile = location.pathname === '/app/profile'
  const isAutomations = location.pathname === '/app/automations'
  const isFavorities = location.pathname === '/app/favorites'

  const { dialog: searchDialog, setOpen, open: searchOpen } = useSearchDialog()

  const currentAction = searchOpen
    ? 'Search'
    : isHome
      ? 'Home'
      : isProfile
        ? 'Profile'
        : isAutomations
          ? 'Automations'
          : isFavorities
            ? 'Favorities'
            : null

  const [dialogOpen, setDialogOpen] = useState(false)

  const plugins = usePlugins('all')

  const handleClose = useCallback(({}: { restoreLayout?: boolean } = {}) => {
    setDialogOpen(false)
  }, [])

  const navigate = useNavigate()
  const handleFavorites = () => navigate('/app/favorites')
  const [toolsDialogOpen, setToolsDialogOpen] = useState(false)

  if (!plugins) {
    return null
  }

  return (
    <>
      <div className={styles.container}>
        <nav className={styles.nav}>
          {[
            { key: 'home', value: 'Home', label: 'Home', icon: <Home />, onClick: () => navigate('/app') },
            ...(createNew && plugins
              ? [{ key: 'nav-new', value: 'New', label: 'New', icon: <Add />, onClick: () => setDialogOpen(true) }]
              : []),
            {
              key: 'nav-tools',
              value: 'Tools',
              label: 'Tools',
              icon: <Tool />,
              onClick: () => setToolsDialogOpen(true),
            },
            { key: 'search', value: 'Search', label: 'Search', icon: <Search />, onClick: () => setOpen(true) },
            {
              key: 'favorites',
              value: 'Favorities',
              label: 'Favorities',
              icon: <Favorite />,
              onClick: handleFavorites,
            },
            {
              key: 'profile',
              value: 'Profile',
              label: 'Profile',
              icon: <Person />,
              onClick: () => navigate('/app/profile'),
            },
            {
              key: 'automations',
              value: 'Automations',
              label: 'Automations',
              icon: <Settings />,
              onClick: () => navigate('/app/automations'),
            },
          ].map(item => (
            <button
              key={item.key}
              onClick={item.onClick}
              className={styles.navButton}
              style={{
                color:
                  currentAction === item.value
                    ? 'var(--tuna-palette-primary-main)'
                    : 'var(--tuna-palette-action-active)',
                opacity: currentAction === item.value ? 1 : 0.7,
              }}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        {entity ? (
          <CreateEntityDialog open={dialogOpen} onClose={handleClose} plugins={plugins} parent={entity} />
        ) : null}
        <ToolsDialog variant="subtitle1" open={toolsDialogOpen} onClose={() => setToolsDialogOpen(false)} />
        {searchDialog}
      </div>
    </>
  )
}
